import { S3_URL } from 'constants/index';
import { IMAGE_PATHS } from 'constants/imagePaths';
import { MyConnectionComponentPropsInterface } from 'constants/interfaces';
import useTranslate from 'hooks/useTranslate';
import React, { useEffect } from 'react';
import { Button, Col, Image, Row, Stack } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useRemoveConnectRequestMutation } from 'services';
import useAuthStore, { updateUserInfo } from 'store/auth';
import useCommonStore, { setModalConfig } from 'store/common';

const MyConnectionComponent: React.FC<MyConnectionComponentPropsInterface> = (props) => {
	const { translate } = useTranslate();
	const { docs = [], meta = {} }: any = props.connectionData;
	const { hideCommonModal }: any = useCommonStore((state) => state);
	const { mutateAsync: removeConnectionMutation } = useRemoveConnectRequestMutation();
	const userDetails: any = useAuthStore((state) => state.userInfo.user);
	const location = useLocation();
	const navigate = useNavigate();

	useEffect(() => {
		if ([location.search].includes('?activeTab=connected&value=')) {
			props.refetchListData('connected');
		}
	}, [location.search]);

	const removeConnection = (id: any) => {
		updateUserInfo({ connection: userDetails?.connection - 1 });
		removeConnectionMutation(id)
			.then((_res: any) => {
				if (_res?.success) {
					hideCommonModal();
					props?.refetchListData('connected');
				} else {
					updateUserInfo({ connection: userDetails?.connection + 1 });
				}
			})
			.catch((err: any) => {
				console.log(err);
			});
	};

	const handleRemoveConnectionModal = (id: any) => {
		setModalConfig({
			visible: true,
			type: 'confirmModal',
			onClick: () => removeConnection(id),
			data: {
				title: translate('Modal.wantToRemoveConnection'),
			},
			props: {
				dialogClassName: 'confirm-modal',
			},
		});
	};

	useEffect(() => {
		if ([location.search].includes('?activeTab=connected&value='))
			if (meta?.totalDocs) {
				updateUserInfo({ connection: meta?.totalDocs || 0 });
			}
	}, [meta?.totalDocs]);

	return (
		<div>
			{meta?.totalDocs > 0 && (
				<h6 className="mb-3">
					{translate('Sidebar.myConnections')}{' '}
					<span className="fw-bold">{`(${meta?.totalDocs})`}</span>
				</h6>
			)}
			<Row className="connections-row">
				{docs?.length > 0 ? (
					docs?.map((res: any) => (
						<Col key={`connection-${res?.name}-${res?.userId}}`} xxl={4} md={6}>
							<Stack className="connections-box gap-3 h-100">
								<div className="d-flex gap-3 h-100">
									<div
										className="connections-box-profile position-relative rounded-circle"
										onClick={() => {
											navigate(`/seeker/profile/${res?.userId}`);
										}}
									>
										<Image
											src={`${S3_URL}${res?.profilePicture}`}
											onError={({ currentTarget }) => {
												currentTarget.onerror = null;
												currentTarget.src = IMAGE_PATHS.UserDefault;
											}}
											alt="logo"
											className="rounded-circle w-100 h-100 object-fit-cover"
											loading="lazy"
										/>
									</div>
									<Stack className="gap-2 flex-1">
										<Link style={{ textDecoration: 'none' }} to={`/seeker/profile/${res?.userId}`}>
											<h6 className="fw-bold mb-0">{res?.name}</h6>
										</Link>
										<p className="mb-0">{res?.description}</p>
										<div className="d-flex gap-2 mt-auto">
											<Button
												onClick={() => {
													handleRemoveConnectionModal(res?.userId);
												}}
												className="gray-transparent-btn rounded-pill lh-1"
											>
												{translate('Button.remove')}
											</Button>
										</div>
									</Stack>
								</div>
							</Stack>
						</Col>
					))
				) : (
					<Col>
						<Stack className="posted-job-box">
							<p className="mb-0">{translate('Common.noConnectionFound')} </p>
						</Stack>
					</Col>
				)}
			</Row>
		</div>
	);
};

export default MyConnectionComponent;
